import axios from 'axios'
import {FUNCTIONS_URL} from '../../config'
import {auth} from '../../Auth'

export default async function archiveForm(formId) {
  const token = await auth.getToken()
  const headers = { 'Content-Type': 'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`
  const {id, name} = auth.sunkaizenUser
  console.log(`Archiving form ${formId} by user ${name} (${id})`)
  const archivedBy = JSON.stringify({id, name})
  const response = await axios.get(`${FUNCTIONS_URL}/utilities/archiveForm`, {
    params: {formId, archivedBy},
    headers,
  })
  if (response?.data) return response.data
  throw new Error('archiveForm returned no data')
}
